import { Grid3X3, List } from "lucide-react";
import { cn } from "@/lib/utils";
import type { GuestCatalogViewMode } from "@/components/guest-catalog/guestCatalogViewMode";

interface GuestCatalogViewToggleProps {
  viewMode: GuestCatalogViewMode;
  onViewModeChange: (mode: GuestCatalogViewMode) => void;
}

export function GuestCatalogViewToggle({
  viewMode,
  onViewModeChange,
}: GuestCatalogViewToggleProps) {
  return (
    <div
      className="flex items-center rounded-lg border border-gray-200"
      role="group"
      aria-label="Catalog view"
    >
      <button
        type="button"
        onClick={() => onViewModeChange("grid")}
        className={cn(
          "rounded-l-lg p-2 transition-colors duration-200",
          viewMode === "grid" ? "bg-gray-100 text-gray-900" : "text-gray-400 hover:text-gray-600"
        )}
        aria-pressed={viewMode === "grid"}
        aria-label="Grid view"
      >
        <Grid3X3 className="h-4 w-4" />
      </button>
      <button
        type="button"
        onClick={() => onViewModeChange("list")}
        className={cn(
          "rounded-r-lg p-2 transition-colors duration-200",
          viewMode === "list" ? "bg-gray-100 text-gray-900" : "text-gray-400 hover:text-gray-600"
        )}
        aria-pressed={viewMode === "list"}
        aria-label="List view"
      >
        <List className="h-4 w-4" />
      </button>
    </div>
  );
}
